import { wrapThemeProvider } from './helpers/testHelpers';
import { createMediaQueries } from './helpers/mediaQueries';
var utils = {
  wrapThemeProvider: wrapThemeProvider,
  createMediaQueries: createMediaQueries
};
export default utils;